import React, { useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const galleryItems = [
  { type: "image", src: "/images/graham1.jpg" },
  { type: "image", src: "/images/pic1.jpg" },
  { type: "image", src: "/images/apartment.png" },
  { type: "video", src: "/videos/compred.mp4" },
  { type: "image", src: "/images/graham2.jpg" },
  { type: "video", src: "/videos/G5.mp4" },
  { type: "image", src: "/images/graham3.jpg" },
  { type: "image", src: "/images/graham4.jpg" },
  { type: "image", src: "/images/graham8.jpg" },
  { type: "image", src: "/images/graham5.jpg" },
];

const Gallery = () => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeVideo, setActiveVideo] = useState(null);

  const imageItems = galleryItems.filter(item => item.type === "image");

  return (
    <section className="bg-white py-20 px-6 md:px-12 lg:px-20">
      {/* Header */}
      <div className="max-w-7xl mx-auto text-center mb-12">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-gray-900"
        >
          Our <span className="text-blue-600">Gallery</span>
        </motion.h2>
        <div className="w-24 h-1 bg-blue-600 mx-auto mt-3 rounded-full"></div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-gray-600 max-w-2xl mx-auto mt-5"
        >
          Explore stunning photos and immersive video tours of our premium
          developments across Ghana.
        </motion.p>
      </div>

      {/* Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {galleryItems.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05, duration: 0.5 }}
            className="relative group cursor-pointer rounded-xl overflow-hidden shadow-lg"
            onClick={() => {
              if (item.type === "image") {
                const imgIndex = imageItems.findIndex(
                  img => img.src === item.src
                );
                setActiveIndex(imgIndex);
                setIsLightboxOpen(true);
              } else {
                setActiveVideo(item.src);
              }
            }}
          >
            {/* Thumbnail */}
            {item.type === "image" ? (
              <img
                src={item.src}
                alt="Gallery item"
                className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110"
              />
            ) : (
              <div className="relative w-full h-72 bg-black">
                <video
                  src={item.src}
                  muted
                  preload="metadata"
                  className="w-full h-full object-cover"
                />
                {/* Play Icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-blue-600/80 rounded-full flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-white ml-1"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M6 4l12 6-12 6V4z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}

            {/* Overlay */}
            <div className="absolute inset-0 bg-blue-600/40 opacity-0 group-hover:opacity-100 transition duration-500 flex items-center justify-center">
              <p className="text-white font-semibold text-lg">
                {item.type === "image" ? "View Image" : "Play Video"}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Image Lightbox */}
      {isLightboxOpen && (
        <Lightbox
          mainSrc={imageItems[activeIndex].src}
          nextSrc={imageItems[(activeIndex + 1) % imageItems.length].src}
          prevSrc={
            imageItems[
              (activeIndex + imageItems.length - 1) % imageItems.length
            ].src
          }
          onCloseRequest={() => setIsLightboxOpen(false)}
          onMovePrevRequest={() =>
            setActiveIndex(
              (activeIndex + imageItems.length - 1) % imageItems.length
            )
          }
          onMoveNextRequest={() =>
            setActiveIndex((activeIndex + 1) % imageItems.length)
          }
        />
      )}

      {/* Video Modal */}
      {activeVideo && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4">
          <div className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden">
            <button
              onClick={() => setActiveVideo(null)}
              className="absolute top-4 right-4 text-white text-2xl z-10"
            >
              ✕
            </button>
            <video
              src={activeVideo}
              controls
              autoPlay
              className="w-full h-auto max-h-[80vh]"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
